export default __webpack_public_path__ + "static/media/i-documento.e8b95f02.svg";